function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WithPromise = /*#__PURE__*/function () {
  function WithPromise() {
    _classCallCheck(this, WithPromise);

    this.updateFinished();
  }

  _createClass(WithPromise, [{
    key: "finished",
    get: function get() {
      return this._finished;
    }
  }, {
    key: "updateFinished",
    value: function updateFinished() {
      var _this = this;

      this._finished = new Promise(function (resolve) {
        _this.resolve = resolve;
      });
    }
  }, {
    key: "notifyFinished",
    value: function notifyFinished() {
      this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */

  }, {
    key: "then",
    value: function then(onResolve, onReject) {
      return this.finished.then(onResolve, onReject);
    }
  }]);

  return WithPromise;
}();

export { WithPromise };